export default __webpack_public_path__ + "static/media/fad-logo-juce.0313bfa2.svg";